<template>
    <v-layout pa-0 ma-0 row justify-space-between v-if="device && device.state">
        <v-flex xs6 class="d-inline-flex align-center">
            <div v-if="showLocation" class="note-row text-left ma-0"> {{device.location}} </div>
        </v-flex>
        <v-flex xs6 class="d-inline-flex justify-end align-center">
            <v-tooltip
                top
                content-class="arrow-down"
                v-model="showBattery"
                v-if="device.state.power == 'battery' && device.state.battery != null"
            >
                <template v-slot:activator="{ on, attrs }">
                    <div
                        class="d-inline-flex"
                        v-bind="attrs"
                        v-on="on"
                        @click.stop.prevent="showBattery = true"
                    >
                        <div v-html="require(`!html-loader!@/assets/icons/battery/${power}.svg`)" class="size-24" />
                    </div>
                </template>
                <span class="main-text">{{device.state.battery}}%</span>
            </v-tooltip>
            <div
                v-else-if="device.state.power == 'mains'"
                v-html="require(`!html-loader!@/assets/icons/battery/plug.svg`)"
                class="size-20"
            />
            <v-tooltip top content-class="arrow-down" v-model="show">
                <template v-slot:activator="{ on, attrs }">
                    <div
                        class="d-inline-flex"
                        v-bind="attrs"
                        v-on="on"
                        @click.stop.prevent="show = true"
                    >
                        <div class="status-marker ml-2">
                            <div :class="device.online ? 'green-color' : 'red-color'"></div>
                        </div>
                    </div>
                </template>
                <span class="main-text">{{device.online ? "online" : "offline"}}</span>
            </v-tooltip>
        </v-flex>
    </v-layout>
</template>

<script>
export default {
    name: "DeviceStatus",
    props: {
        device: {
            type: [Array, Object],
            default: null,
        },
        showLocation: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            show: false,
            showBattery: false,
        };
    },
    computed: {
        power() {
            if (this.device.state && this.device.state.power && this.device.state.power == "battery") {
                return this.device.state.battery < 11 ?
                    "empty" : this.device.state.battery < 16 ?
                        "low" : this.device.state.battery < 41 ?
                            "quarter" : this.device.state.battery < 61 ?
                                "half" : this.device.state.battery < 81 ?
                                    "most" : !this.device.state.battery ?
                                        "unknown" : "full";
            }
        },
    },
}
</script>

<style lang="scss" scoped>
.status-marker {
    align-items: center;
    display: inline-flex;

    .green-color,
    .red-color {
        height: 12px;
        width: 12px;
        border-radius: 6px;
    }

    .green-color {
        background: #42D829;
    }

    .red-color {
        background: var(--dark-red-1);
    }
}

.v-tooltip__content {
    background: var(--dark-gradient);
    border-radius: 30px;
    padding: 16px;

    &.menuable__content__active {
        opacity: 1;

        &.arrow-down {
            overflow: inherit !important;
            z-index: 7;

            &::before {
                content: '';
                position: absolute;
                left: 50%;
                top: 100%;
                border: 5px solid #FF8484;
                border-color: #FF8484 transparent transparent transparent;
                opacity: 0.8;
            }
        }
    }
}
</style>